const selectAffiliate = (state: RootState) => state.affiliate.affiliate;

export { selectAffiliate };
